<script setup lang="ts">
const props = defineProps({
  description: {
    type: String,
    default: () => "",
  },
  premiere: {
    type: String,
    default: () => "",
  },
  title: {
    type: String,
    default: () => "О спектакле",
  },
});

// @ts-ignore
const _description = ref<HTMLElement>(null);
const text = ref("");

onMounted(() => {
  if (_description.value.scrollHeight <= 70) {
    text.value = "";
  } else {
    text.value = "Читать далее";
  }
});

const isShow = ref(false);

function showDetails() {
  isShow.value = !isShow.value;
  if (isShow.value) {
    _description.value.style.height = _description.value.scrollHeight + "px";
    text.value = "Скрыть";
  } else {
    _description.value.style.height = 70 + "px";
    text.value = "Читать далее";
  }
}
</script>

<template>
  <div class="flex flex-col space-y-7" v-if="description">
    <div class="w-full text-left">
      <h4 class="text-xl font-sans text-dark-gray">{{ title }}</h4>
      <h6 class="font-sans font-base text-primary">Премьера: {{ premiere }}</h6>
    </div>
    <div>
      <div
        class="w-full text-left v-html"
        ref="_description"
        :class="isShow ? 'showDetails' : 'hideDetails'"
        v-html="description"
      ></div>
      <div
        class="w-fit text-base pt-2 text-primary-900 cursor-pointer font-sans"
        @click="showDetails()"
      >
        {{ text }}
      </div>
    </div>
  </div>
</template>

<style scoped>
.hideDetails {
  transition: all 0.15s ease-out;
  overflow: hidden;
  height: 70px;
}

.showDetails {
  overflow: hidden;
  transition: all 0.15s ease-out;
}
</style>
